import { ToolbarService } from './toolbar.service';

export const providers = [ToolbarService];
